<template>
    <div class="form-info">
        <div class="form-row">
            <div class="form-label">
                <label>机构名称:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.retailerComName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>耗材名称:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.title}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>品牌:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.brandName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>分类:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.catName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>分类分组：</label>
            </div>
            <div class="form-value">
                <span>{{getDevcGroupNameByCatId(shopDevice.catId)}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>数量:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.quantity}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>单位:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.theUnit}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>关联定义:</label>
            </div>
            <div class="form-value">
                <span>{{shopDevice.devcDefId == -1 ? '未关联' : '已关联'}}</span>
            </div>
        </div>
        <div class="form-single">
            <div class="title">耗材图片</div>
            <div class="content" style="padding-left: 126px" v-if="shopDevice.imageUrl != null && shopDevice.imageUrl.length > 0">
                <div class="file-area clearfix">
                    <div class="file-item image viewable downloadable">
                        <div class="file-content" @click="viewImage(shopDevice.imageUrl)">
                            <img :src="shopDevice.imageUrl"/>
                            <div class="operation-group">
                                <i class="icon iconfont icon-chakan view"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>无</div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openBigImgDlg } from '../comn/dialog'
    import { getDevcGroupNameByCatId } from '../index'

    export default {
        name: 'swb-shop-device-lowcost-detail',
        desc: '机构耗材详情',
        props: ['shopDevice'],
        data: function () {
            return {}
        },
        created: function () {
        },
        methods: {
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/ShopDeviceLowCost/ShopDeviceLowCostDetail.vue